import { Grid } from '@mantine/core';
import React from 'react';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    ProjectUserRoleMutationResourceSchema,
    ProjectUserRolePropertyValidation,
    type ProjectUserRoleResource,
    useProjectUserRoleActions,
} from '../../../../resource/resources/persistables/user/projectUserRoleResource';
import { PropertyInputs } from '../../../reusable-components/base/property-bases/PropertyInputs';
import { EditChildBaseDialog } from '../../../reusable-components/dialogs/EditChildBaseDialog';
import {
    Form_DisplayComponentBaseView,
} from '../../../reusable-components/form-components/Form_DisplayComponentBaseView';

export const ProjectUserRoleCreateAndEditDialog= ({ label, onClose, projectUserRole, parentId, setProjectUserRole }: {
    projectUserRole: ProjectUserRoleResource;
    label: string;
    onClose: () => void;
    parentId: string | undefined;
    setProjectUserRole?: (newResource: ProjectUserRoleResource) => void;
}) => {
    const projectUserRoleActions = useProjectUserRoleActions()
    const addRole = projectUserRoleActions.useAddResource();
    const updateRole = projectUserRoleActions.useUpdateResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: ProjectUserRoleMutationResourceSchema,
        defaultValues: projectUserRole,
        submitHandler: async (data) => {
            if (data.id !== '') {
                await updateRole.mutateAsync(
                    {
                        resource: data,
                        id: data.id,
                    },
                    { onSuccess: onClose },
                );
            } else if (parentId !== undefined) {
                await addRole.mutateAsync(
                    {
                        resource: data,
                        parentId,
                    },
                    { onSuccess: onClose },
                );
            } else if (setProjectUserRole) {
                setProjectUserRole(data);
                onClose();
            }
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={label}
            resourceType={ResourceType.PROJECT_USER_ROLE}
        >
            <Form_DisplayComponentBaseView form={form} onSubmit={onSubmit} canSubmitDefaultValue={false}>
                <Grid>
                    <Grid.Col span={6}>
                        <PropertyInputs.Name
                            name={formNames.name}
                            control={form.control}
                            readOnly={false}
                            propertyValidationInformation={{
                                resourceId: projectUserRole.id,
                                resourceType: ResourceType.PROJECT_USER_ROLE,
                                propertyIdentifier: ProjectUserRolePropertyValidation.NAME,
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={12}>
                        <PropertyInputs.MultilineString
                            name={formNames.description}
                            control={form.control}
                            nullable={false}
                            readOnly={false}
                            propertyValidationInformation={{
                                resourceId: projectUserRole.id,
                                resourceType: ResourceType.PROJECT_USER_ROLE,
                                propertyIdentifier: ProjectUserRolePropertyValidation.DESCRIPTION,
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={4}>
                        <PropertyInputs.Boolean
                            name={formNames.isManager}
                            control={form.control}
                            readOnly={false}
                            propertyValidationInformation={{
                                resourceId: undefined,
                                resourceType: ResourceType.PROJECT_USER_ROLE,
                                propertyIdentifier: ProjectUserRolePropertyValidation.IS_MANAGER,
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={4}>
                        <PropertyInputs.Boolean
                            name={formNames.isProcessAdmin}
                            control={form.control}
                            readOnly={false}
                            propertyValidationInformation={{
                                resourceId: undefined,
                                resourceType: ResourceType.PROJECT_USER_ROLE,
                                propertyIdentifier: ProjectUserRolePropertyValidation.IS_PROCESS_ADMIN,
                            }}
                        />
                    </Grid.Col>
                    <Grid.Col span={4}>
                        <PropertyInputs.Boolean
                            name={formNames.isReader}
                            control={form.control}
                            readOnly={false}
                            propertyValidationInformation={{
                                resourceId: undefined,
                                resourceType: ResourceType.PROJECT_USER_ROLE,
                                propertyIdentifier: ProjectUserRolePropertyValidation.IS_READER,
                            }}
                        />
                    </Grid.Col>
                </Grid>
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};


